var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay20240716235257(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0c1c3c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m79.86,47.58L8.76,6.53c-2.49-1.44-5.6.36-5.6,3.23v82.1c0,2.87,3.11,4.67,5.6,3.23l71.1-41.05c2.49-1.44,2.49-5.03,0-6.47Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay20240716235257);
export default __webpack_public_path__ + "static/media/PLAY-20240716-235257.933a4a10a328bb63abb792a50b452ab3.svg";
export { ForwardRef as ReactComponent };